import { atom } from 'recoil';

export const orderPayload = atom({
    key: 'co-orderPayload',
    default: {
        appProfile: null,
        appProfileDetails: null,
        appName: null,
        applicationName: null,
        appShortName: null,
        applicationName1: null,
        appShortName1: null,
        awsSector: null,
        awsSectorDetails: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        landingZoneDetails: null,
        businessCategory: null,
        region: null,
        regionDisplayname: null,
        environments: [],
        awsEnvironment: null,
        awsAccountName: null,
        awsOrgUnit: null,
        awsOrgUnitDetails: null,
        hCode: null,
        hCodeDetails: null,
        onPremHCode: null,
        onPremHCodeDetails: null,
        additionalInfo: null,
        businessAppDetails: null,
        businessApp: null,
        businessSponsor: null,
        businessSponsorDetails: null,
        dataClassification: null,
        entityDetails: null,

        // Resource Setion
        cloudType: null,
        isaNumber: null,
        onboardingCategory: null,
        isCSAApprovalsComplete: null,
        // csaApprovedArch: 'no',
        tacRequest: null,
        prevCloudOnboardReq: null,
        csa: null,
        csaDetails: null,
        nonPrivilegedADGroupList: [{ readerValue: '' }],
        privilegedADGroupList: [{ contributorValue: '' }],
        privilegedADGroup: null,
        nonPrivilegedADGroup: null,
        privilegedADGroupOwner: null,
        privilegedADGroupOwnerDetails: null,
        nonPrivilegedADGroupOwner: null,
        nonPrivilegedADGroupOwnerDetails: null,
        deletedFiles: [],
        isChinaRegion: 'no',
        adGroup: null,

        // Questionnaire
        questionnaire: {
            'Do you need assistance with provisioning cloud resources?': [],
            'Do you need help for raising an ISA?': '',
            'Do you need guidance through the NSG intake process?': '',
            'Does your app need to talk to anything outside cloud—for example: PEP on-prem systems or other internet endpoints (Firewall support)?': '',
        },

        estimatedCost: {
            details: [],
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'There is no cost for this Cloud onboarding request, however there will be cost involved based on the service Name defined at the Resource Group level for your resources that being provisioned in future.',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const urlParams = atom({
    key: 'co-urlParams',
    default: {
        journeyId: null,
        appRegistrationId: null,
    },
});

export const isValidApplicationName = atom({
    key: 'co-validApplicationName',
    default: false,
});
export const isAppNameValid = atom({
    key: 'co-isAppNameValid',
    default: true,
});
export const isAppNameValid1 = atom({
    key: 'co-isAppNameValid1',
    default: true,
});

export const isAppShortNameValid = atom({
    key: 'co-isAppShortNameValid',
    default: false,
});
export const isAppShortNameExist = atom({
    key: 'co-isAppShortNameExist',
    default: false,
});

export const isValidISANumber = atom({
    key: 'co-isValidISANumber',
    default: false,
});

export const isCostcenterValid = atom({
    key: 'co-isCostcenterValid',
    default: false,
});

export const isValidOwners = atom({
    key: 'co-isValidOwners',
    default: {
        isvalidAppOwner: true,
        isvalidCertificateOwner1: true,
        isvalidCertificateOwner2: true,
    },
});

export const toggleSspModels = atom({
    key: 'co-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isNonPrivilegedADGroupOpen: false,
        isPrivilegedADGroupOpen: false,
        isADGroupModalOpen: false,
    },
});

export const costEstimateState = atom({
    key: 'co-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'co-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const orderId = atom({
    key: 'co-orderId',
    default: '',
});

export const isNonPrivilegedADGroupValid = atom({
    key: 'co-isNonPrivilegedADGroupValid',
    default: false,
});

export const isPrivilegedADGroupValid = atom({
    key: 'co-isPrivilegedADGroupValid',
    default: false,
});

export const SecondaryApprover = atom({
    key: 'co-secondaryApprover',
    default: { selectedFieldFrom: { module: null, subModule: null }, value: { groupOwner: null, groupOwnerDetails: null } },
});

export const isValidCloudDocLink = atom({
    key: 'co-isValidCloudDocLink',
    default: false,
});

export const uploadedFilesState = atom({
    key: 'co-uploadedFilesState',
    default: [],
});
